/**
 * @purpose: mengelola form input dan tampilan Tracking CN (lookup AWB/CN dan PO).
 * @called_by: views/app_outbound/tracking_cn.html
 * @deps: urlServices, toaster
 * @public: controller AngularJS trackingCnCtrl
 * @side_effects: memanggil API /api/tracking-cn/awb/:awb dan /api/tracking-cn/po/:po, menampilkan hasil tracking.
 */
app.controller('trackingCnCtrl', function ($scope, urlServices, toaster) {
    $scope.searchMode = 'awb'; // 'awb' or 'po'
    $scope.searchValue = '';
    $scope.loading = false;
    $scope.result = null;
    $scope.notFound = false;

    $scope.setSearchMode = function (mode) {
        $scope.searchMode = mode;
        $scope.searchValue = '';
        $scope.result = null;
        $scope.notFound = false;
    };

    $scope.doSearch = function () {
        if (!$scope.searchValue || !$scope.searchValue.trim()) {
            return toaster.pop('warning', 'Tracking CN', $scope.searchMode === 'awb' ? 'Nomor CN/AWB harus diisi' : 'Nomor PO/Reff harus diisi');
        }

        $scope.loading = true;
        $scope.result = null;
        $scope.notFound = false;

        var endpoint = $scope.searchMode === 'awb'
            ? 'api/tracking-cn/awb/' + encodeURIComponent($scope.searchValue.trim())
            : 'api/tracking-cn/po/' + encodeURIComponent($scope.searchValue.trim());

        urlServices.ambilData(endpoint, {}, function (err, data) {
            $scope.loading = false;

            if (err) {
                $scope.notFound = true;
                return toaster.pop('error', 'Tracking CN', err.err || err || 'Data tidak ditemukan');
            }

            if (!data || !data.master) {
                $scope.notFound = true;
                return toaster.pop('info', 'Tracking CN', $scope.searchMode === 'awb' ? 'CN/AWB tidak ditemukan' : 'PO/Reff tidak ditemukan');
            }

            $scope.result = data;
        });
    };

    $scope.clearResult = function () {
        $scope.searchValue = '';
        $scope.result = null;
        $scope.notFound = false;
    };

    $scope.formatDate = function (val) {
        if (!val) return '-';
        var d = new Date(val);
        if (isNaN(d.getTime())) return val;
        var dd = ('0' + d.getDate()).slice(-2);
        var mm = ('0' + (d.getMonth() + 1)).slice(-2);
        var yyyy = d.getFullYear();
        return dd + '-' + mm + '-' + yyyy;
    };

    $scope.formatNumber = function (val, decimals) {
        if (val === null || val === undefined || val === '') return '0';
        var num = Number(val);
        if (isNaN(num)) return val;
        return num.toFixed(decimals !== undefined ? decimals : 0);
    };
});
